/* eslint-disable no-console */

import { register } from 'register-service-worker'
if (
    process.env.NODE_ENV === 'development' || // 테스트를 위해서 dev일때도 등록해준다.
    process.env.NODE_ENV === 'production') {
  /*
   개발 중에 localhost를 통해 서비스 워커를 사용할 수 있지만 사이트에 배포하려면 서버에 HTTPS 설정을 해야 합니다.
   웹 어플리케이션의 호스트가 localhost이거나 HTTPS 프로토콜을 사용하고 있을 경우에만 service worker를 붙일 수 있다.
   따라서 개발에서는 http://localhost:8080으로 붙어야만 service worker가 동작한다.
   */
  register(`${process.env.BASE_URL}service-worker.js`, {
    ready () {
      console.log(
        'App is being served from cache by a service worker.\n' +
        'For more details, visit https://goo.gl/AFskqB'
      )
    },
    registered () {
      console.log('Service worker has been registered.')
    },
    cached () {
      console.log('Content has been cached for offline use.')
    },
    updatefound () {
      console.log('New content is downloading.')
    },
    updated () {
      console.log('New content is available; please refresh.')
    },
    offline () {
      console.log('No internet connection found. App is running in offline mode.')
    },
    error (error) {
      console.error('Error during service worker registration:', error)
    }
  })
}
